window.load_callbacks = [];
window.custom_loaded = false;
window.added_scripts = false;

function CUSTOM_LOAD(callback) {
  if (window.custom_loaded) {
    callback();
    return;
  }

  window.load_callbacks.push(callback);
}


window.LOADED = () => {
  console.debug("JQUERY FOUND");
  addScripts.call(this);
  setTimeout(() => {
    window.custom_loaded = true;
    window.load_callbacks.forEach((cback) => cback.call(this));
    window.load_callbacks = [];
  }, 1000);

  window.clearInterval(waitForJQuery);
};

var waitForJQuery = window.setInterval(() => {
  if (typeof $ != "undefined") {
    window.LOADED();
  } else {
    console.debug("WAITING FOR JQUERY");
  }
}, 100);

// yt popout

function YT_openModal(embedLink) {
  const modalOverlay = document.getElementById("modal-overlay");
  const videoContainer = document.getElementById("video-container");
  // Set the video embed code
  const embedCode = `<iframe style="max-width: 100%;" width="560" height="315" src="${embedLink}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen=""></iframe>`;
  videoContainer.innerHTML = embedCode;
  // Display the modal
  modalOverlay.style.display = "flex";
}

function YT_closeModal() {
  const modalOverlay = document.getElementById("modal-overlay");
  const videoContainer = document.getElementById("video-container");
  // Hide the modal
  modalOverlay.style.display = "none";
  // Remove the video embed code to stop playback
  videoContainer.innerHTML = "";
}

// end yt popout
